module.exports = __webpack_public_path__ + "static/media/satellite@2x.fff6321b.jpeg";